import styled from 'styled-components';

export const PlatformCommissionsContainer = styled.div`
  width: 100%;
`;

export const PlatformSection = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PlatformTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: #2f3d48;
  margin-bottom: 16px;
`;

export const CommissionField = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
  justify-content: space-between;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CommissionInputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  min-width: 130px;
  justify-content: flex-end;
`;

export const ErrorMessage = styled.div`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  color: #ff2d38;
  margin-top: 4px;
`;

export const InfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #929cb9;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  margin-left: 8px;
  cursor: help;
`;
